import React, { useContext } from "react";
import PropTypes from "prop-types";
import DataTable from "../../../../components/DataTable";
import { LOCATION_COLUMNS } from "../columns";

import { ALL_COMPANY_LOCATIONS_QUERY } from "../../../../graphql/Company/CompanyLocations.graphql";

import { ModalContext } from "../../../../components/ModalProvider";

import { EditCompanyLocationForm } from "../../../../components/Company/Locations";

const Locations = ({ codes }) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <DataTable
      columns={LOCATION_COLUMNS}
      dataQuery={ALL_COMPANY_LOCATIONS_QUERY}
      name="CompanyLocation"
      where={{ Active: true }}
      onRowClick={location =>
        setModalOpen(
          true,
          <EditCompanyLocationForm
            codes={codes}
            companyLocation={location}
            setModalOpen={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
};
Locations.propTypes = {
  codes: PropTypes.array
};
export default Locations;
